import Leads from './Leads';
import LeadDetails from './LeadDetails';

export default Leads;
export { LeadDetails };
